var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayButton = function SvgPlayButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 110 60"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 58,
    x: 1,
    y: 1,
    fill: "#fff",
    rx: 8.57
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 58,
    x: 1,
    y: 1,
    stroke: "#7B4EF8",
    strokeWidth: 2,
    rx: 8.57
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#7B4EF8",
    strokeWidth: 2,
    d: "m45.215 14.778 22.272 14.225a1.61 1.61 0 0 1 0 2.714L45.215 45.942c-1.072.684-2.477-.085-2.477-1.357v-28.45c0-1.272 1.405-2.042 2.477-1.357Z"
  })));
};
export default SvgPlayButton;